var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncreaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99995 16.25C9.30371 16.25 9.54995 16.4962 9.54995 16.8L9.54995 18.6C9.54995 18.9038 9.30371 19.15 8.99995 19.15C8.69619 19.15 8.44995 18.9038 8.44995 18.6L8.44995 16.8C8.44995 16.4962 8.69619 16.25 8.99995 16.25Z",
    fill: "#383634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1999 17.45C7.50366 17.45 7.7499 17.6963 7.7499 18L7.7499 18.6C7.7499 18.9038 7.50366 19.15 7.1999 19.15C6.89615 19.15 6.6499 18.9038 6.6499 18.6L6.6499 18C6.6499 17.6963 6.89615 17.45 7.1999 17.45Z",
    fill: "#383634"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 15.05C11.1038 15.05 11.35 15.2962 11.35 15.6L11.35 18.6C11.35 18.9037 11.1038 19.15 10.8 19.15C10.4962 19.15 10.25 18.9037 10.25 18.6L10.25 15.6C10.25 15.2962 10.4962 15.05 10.8 15.05Z",
    fill: "#383634"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 13.85C12.9038 13.85 13.15 14.0962 13.15 14.4L13.15 18.6C13.15 18.9037 12.9038 19.15 12.6 19.15C12.2963 19.15 12.05 18.9037 12.05 18.6L12.05 14.4C12.05 14.0962 12.2963 13.85 12.6 13.85Z",
    fill: "#383634"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 12.65C14.7039 12.65 14.9501 12.8963 14.9501 13.2L14.9501 18.6C14.9501 18.9038 14.7039 19.15 14.4001 19.15C14.0963 19.15 13.8501 18.9038 13.8501 18.6L13.8501 13.2C13.8501 12.8963 14.0963 12.65 14.4001 12.65Z",
    fill: "#383634"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1999 9.04999C16.5037 9.04999 16.7499 9.29623 16.7499 9.59999L16.7499 18.6C16.7499 18.9037 16.5037 19.15 16.1999 19.15C15.8961 19.15 15.6499 18.9037 15.6499 18.6L15.6499 9.59999C15.6499 9.29623 15.8961 9.04999 16.1999 9.04999Z",
    fill: "#383634"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8112 8.6111C16.026 8.39632 16.3742 8.39632 16.589 8.6111L18.389 10.4111C18.6038 10.6259 18.6038 10.9741 18.389 11.1889C18.1742 11.4037 17.826 11.4037 17.6112 11.1889L16.2001 9.77783L14.789 11.1889C14.5742 11.4037 14.226 11.4037 14.0112 11.1889C13.7964 10.9741 13.7964 10.6259 14.0112 10.4111L15.8112 8.6111Z",
    fill: "#383634"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6803 0.452422C11.8716 0.315827 12.1284 0.315827 12.3197 0.452422L22.5197 7.73814C22.6642 7.84138 22.75 8.00807 22.75 8.18569V17.9C22.75 18.2037 22.5038 18.45 22.2 18.45C21.8962 18.45 21.65 18.2037 21.65 17.9V8.46873L12 1.57587L2.35 8.46873V21.35H16.2C16.5038 21.35 16.75 21.5962 16.75 21.9C16.75 22.2037 16.5038 22.45 16.2 22.45H1.8C1.49624 22.45 1.25 22.2037 1.25 21.9V8.18569C1.25 8.00807 1.33578 7.84138 1.48032 7.73814L11.6803 0.452422Z",
    fill: "#383634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIcon);
export default __webpack_public_path__ + "static/media/increase_icon.8728b509b981ef79888971c57cf89261.svg";
export { ForwardRef as ReactComponent };